import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DasboardTabLayoutComponent } from './components/dasboard-tab-layout/dasboard-tab-layout.component';
import { LayoutComponent } from 'src/app/layout/layout.component';
import { MulticityDashboardTabLayoutComponent } from './components/multicity-dashboard-tab-layout/multicity-dashboard-tab-layout.component';
import { authGuard } from 'src/app/shared/guards/auth.guard';


 
 
const routes: Routes = [
  {
    path: 'Dashboard',
    component: LayoutComponent,
    canActivate:[authGuard],
    children: [
      {
        path: '',
        component: DasboardTabLayoutComponent
      },
      {
        path: 'Multicity/FlightSearch',
        component: MulticityDashboardTabLayoutComponent
      }
     
    ]
  
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes,)],
  exports: [RouterModule],
})
export class DashboardRoutingModule { }
